import { useState, useRef } from "react";
import { default as ReactSelect, components } from "react-select";

const CustomMultiSelect = (props) => {
  const [selectInput, setSelectInput] = useState("");
  const isAllSelected = useRef(false);
  const selectAllLabel = useRef("Select all");
  const allOption = { value: "*", label: selectAllLabel.current };

  const filterOptions = (options, input) =>
    options?.filter(({ label }) =>
      label.toLowerCase().includes(input.toLowerCase())
    );

  const comparator = (v1, v2) => v1.value - v2.value;

  let filteredOptions = filterOptions(props.options, selectInput);
  let filteredSelectedOptions = filterOptions(props.value, selectInput);
  const filteredUnselectedOptions = props.options.filter(
    (option) => !props.value.some((selected) => selected.value === option.value)
  );

  const Option = (props) => (
    <components.Option  {...props}>
      <label style={{ marginLeft: "5px" }}>{props.label}</label>
    </components.Option>
  );

  const Input = (props) => (
    <>
      {selectInput.length === 0 ? (
        <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
          {props.children}
        </components.Input>
      ) : (
        <div style={{ border: "1px dotted gray" }}>
          <components.Input autoFocus={props.selectProps.menuIsOpen} {...props}>
            {props.children}
          </components.Input>
        </div>
      )}
    </>
  );

  const customFilterOption = ({ value, label }, input) =>
    (value !== "*" && label.toLowerCase().includes(input.toLowerCase())) ||
    (value === "*" && filteredOptions?.length > 0);

  const onInputChange = (inputValue, event) => {
    if (event.action === "input-change") setSelectInput(inputValue);
    else if (event.action === "menu-close" && selectInput !== "")
      setSelectInput("");
  };

  const onKeyDown = (e) => {
    if ((e.key === " " || e.key === "Enter") && !selectInput)
      e.preventDefault();
  };

  const handleChange = (selected) => {
    if (
      selected.length > 0 &&
      !isAllSelected.current &&
      (selected[selected.length - 1].value === allOption.value ||
        JSON.stringify(filteredOptions) ===
        JSON.stringify(selected.sort(comparator)))
    )
      return props.onChange(
        [
          ...(props.value ?? []),
          ...props.options.filter(
            ({ label }) =>
              label.toLowerCase().includes(selectInput?.toLowerCase()) &&
              (props.value ?? []).filter((opt) => opt.label === label).length ===
              0
          ),
        ].sort(comparator)
      );
    else if (
      selected.length > 0 &&
      selected[selected.length - 1].value !== allOption.value &&
      JSON.stringify(selected.sort(comparator)) !==
      JSON.stringify(filteredOptions)
    )
      return props.onChange(selected);
    else
      return props.onChange([
        ...props.value?.filter(
          ({ label }) =>
            !label.toLowerCase().includes(selectInput?.toLowerCase())
        ),
      ]);
  };

  const customStyles = {
    control: (styles) => ({ ...styles, backgroundColor: '#F9FAFB', width: "100%", borderRadius: "12px", borderColor: "#E1E7EC" }),

    singleValue: (styles) => ({ ...styles, color: "#809FB8" }),
    placeholder: (styles) => ({ ...styles, color: "#c0cfdc" }),
    multiValueLabel: (def) => ({
      ...def,
      backgroundColor: "lightgray",
    }),
    multiValueRemove: (def) => ({
      ...def,
      backgroundColor: "lightgray",
    }),
    container: (base) => ({
      ...base,
      width: "100%"
    }),
    valueContainer: (base) => ({
      ...base,
      height: "48px",

    }),
    option: (styles, { isSelected, isFocused }) => {
      return {
        ...styles,
        backgroundColor:
          isSelected && !isFocused
            ? null
            : isFocused && !isSelected
              ? styles.backgroundColor
              : isFocused && isSelected
                ? "#DEEBFF"
                : null,
        color: isSelected ? null : null,
      };
    },
    menu: (def) => ({ ...def,  }),
  };

  if (props.isSelectAll && props.options.length !== 0) {
    isAllSelected.current =
      JSON.stringify(filteredSelectedOptions) ===
      JSON.stringify(filteredOptions);

    return (

      <div style={{ width: "100%" }}>
        <ReactSelect
          {...props}
          // className="react-select"
          onInputChange={onInputChange}
          onKeyDown={onKeyDown}
          options={filteredUnselectedOptions}
          onChange={handleChange}
          components={{
            Option: Option,
            Input: Input,
            ...props.components,
          }}
          filterOption={customFilterOption}
          menuPlacement={props.menuPlacement ?? "auto"}
          styles={customStyles}
          isMulti
          closeMenuOnSelect={false}
          tabSelectsValue={false}
          backspaceRemovesValue={false}
          hideSelectedOptions={false}
          blurInputOnSelect={false}
          isLoading={props.isLoading}
          
        menuPlacement='auto'
        />
      </div>
    );
  }
  return (

    <div style={{ height: "64px" }}>
      <ReactSelect
        {...props}
        className="react-select"
        // inputValue={selectInput}
        onInputChange={onInputChange}
        filterOption={customFilterOption}
        value={props.value}
        components={{
          Input: Input,
          ...props.components,
        }}
        menuPlacement={props.menuPlacement ?? "auto"}
        styles={customStyles}
        onKeyDown={onKeyDown}
        tabSelectsValue={false}
        hideSelectedOptions={true}
        backspaceRemovesValue={false}
        blurInputOnSelect={true}
        menuPlacement='auto'
      />
    </div>
  );
};

export default CustomMultiSelect;